import React from "react";
import { getFallbackImageFromUrl, _getImageFromUrl } from "../../utils/imageService";
import BrandificationImageFallback from "../BrandificationImageFallback";

const ImageContainer = ({ image, width, ...props }) => {
  const containerStyle = {
    width: width || "65%",
  };

  return (
    <div className="image-container" style={containerStyle}>
      {image ? (
        <BrandificationImageFallback
          src={_getImageFromUrl(image)}
          fallbackImage={getFallbackImageFromUrl(image)}
          className="media-image"
          {...props}
        />
      ) : (
        <span className="no-image" />
      )}
    </div>
  );
};

export default ImageContainer;
